import React from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../Header/Header'
import Router from '../../Router/Routers'
import Footer from '../Footer/Footer'

const Layout = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  return (
    <div>
        {!isAdminRoute && <Header/>}
        <Router/>
        {!isAdminRoute && <Footer/>}
    </div>
  )
}

export default Layout